import type { JSX } from 'react';

import { ArrowBackIcon } from '../svgs/ArrowBack';
import { ArrowDownwardIcon } from '../svgs/ArrowDownward';
import { ArrowForwardIcon } from '../svgs/ArrowForward';
import { ArrowUpwardIcon } from '../svgs/ArrowUpward';
import type { Direction, SVGProps } from '../types';

type CompleteArrowForwardProps = SVGProps & { direction?: Direction };

const CompleteArrowForwardIcon = (
  props: CompleteArrowForwardProps,
): JSX.Element => {
  const { direction = 'right', title, ...restProps } = props;

  const iconTitle = title || `CompleteArrowForward-${direction}`;

  switch (direction) {
    case 'left':
      return <ArrowBackIcon title={iconTitle} {...restProps} />;
    case 'up':
      return <ArrowUpwardIcon title={iconTitle} {...restProps} />;
    case 'down':
      return <ArrowDownwardIcon title={iconTitle} {...restProps} />;
    case 'right':
    default:
      return <ArrowForwardIcon title={iconTitle} {...restProps} />;
  }
};

export { CompleteArrowForwardIcon };
